import { Select } from "antd";
import { setCurrentPageNo } from "pages/UserManagement/userSlice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DeleteIcon, EditIcon, TableDatePicker } from "themes/Icon";
import AvatarComp from "themes/elements/Avatar";
import ButtonComp from "themes/elements/Button";
import DateRangePickerComp from "themes/elements/DateRangePickerComp";
import EmptyState from "themes/elements/EmptyState";
import PaginationComp from "themes/elements/Pagination";
import SearchComp from "themes/elements/Search";
import SelectComp from "themes/elements/Select";
import TagComp from "themes/elements/Tag";
import TooltipComp from "themes/elements/Tooltip";
import { isPermit } from "utils/permissionCheck";
import "../table_comp.scss";

export default function CouncillorsTable({
  column,
  data,
  onDeleteAction,
  handleEdit,
  setSelectedData = () => {},
  isLoading,
  editAction,
  onDataClick,
  filterName,
  filterMail,
  filterPhone,
  setFilterPhone,
  filterStatus,
  filterWard,
  filterCreatedDate,
  filterTerm,
  setFilterTerm = () => {},
  setFilterName = () => {},
  setFilterCreatedDate = () => {},
  setFilterExpiryDate = () => {},
  setFilterMail = () => {},
  setFilterWard = () => {},
  setFilterStatus = () => {},
}) {
  const [currentPageData, setCurrentPageData] = useState([]);
  const { wards, totalPageNo, currentPageNo } = useSelector(
    (state) => state.counsilor
  );
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentPageData(data);
    setSelectedData([]);
  }, [data]);

  const handlePageChange = (page) => {
    dispatch(setCurrentPageNo(page));
  };

  const handleCreatedDateChange = (dateString) => {
    dispatch(setCurrentPageNo(1));
    if (dateString) {
      setFilterTerm(dateString);
    } else {
      setFilterTerm(null);
    }
  };

  const handleStatusChange = (value, item) => {
    dispatch(setCurrentPageNo(1));
    setFilterStatus(item);
  };

  const handleSearchChange = (event, type) => {
    dispatch(setCurrentPageNo(1));
    const value = event.target.value;
    if (type === "title") {
      setFilterName(value);
    } else if (type === "phone") {
      setFilterPhone(value);
    } else {
      setFilterMail(value);
    }
  };

  const handleWardChange = (value, item) => {
    dispatch(setCurrentPageNo(1));
    setFilterWard(value);
  };

  const SkeletonRow = ({ columns }) => (
    <tr className="table-row">
      {columns.map((col, index) => (
        <td key={index} className="table-data" style={{ width: col.width }}>
          <div className="skeleton-box"></div>
        </td>
      ))}
    </tr>
  );

  const clearFilters = () => {
    dispatch(setCurrentPageNo(1));
    setFilterTerm();
    setCurrentPageData(data);
    setFilterPhone(null);
    setFilterName("");
    setFilterWard();
    setFilterCreatedDate(null);
    setFilterMail("");
    setFilterExpiryDate(null);
    setFilterStatus({ value: 2, name: "All" });
  };

  return (
    <div className="table-wrapper">
      <table className="table-comp">
        <thead className="table-head">
          <tr className="table-row">
            {column?.map((col, i) => (
              <th
                className="table-header"
                key={i}
                style={{ minWidth: col.width }}
              >
                <span className="flex align-center gap-3">{col.title}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="table-body">
          <tr className="table-row">
            {column?.map((col, i) => (
              <td className="table-data" style={{ width: col.width }} key={i}>
                {col.filter === "searchName" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterName}
                    onChange={(e) => handleSearchChange(e, "title")}
                  />
                ) : col.filter === "searchMail" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterMail}
                    onChange={(e) => handleSearchChange(e, "mail")}
                  />
                ) : col.filter === "searchPhone" ? (
                  <SearchComp
                    className="table-search"
                    height={33}
                    bgNone
                    placeholder="Search..."
                    value={filterPhone}
                    onChange={(e) => handleSearchChange(e, "phone")}
                  />
                ) : col.filter === "selectWards" ? (
                  <Select
                    showSearch
                    className="chip-select-search color-select"
                    style={{ width: "100%" }}
                    popupClassName="select-popover color-select-popover"
                    value={filterWard}
                    placeholder="Wards"
                    onChange={handleWardChange}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {wards.map((ward) => (
                      <Option key={ward.value.trim()} value={ward.value.trim()}>
                        {ward.value}
                      </Option>
                    ))}
                  </Select>
                ) : col.filter === "termPicker" ? (
                  <DateRangePickerComp
                    className="table-date-picker"
                    suffixIcon={<TableDatePicker />}
                    onChange={handleCreatedDateChange}
                    value={filterTerm}
                    setValue={setFilterTerm}
                  />
                ) : col.filter === "selectStatus" ? (
                  <SelectComp
                    value={filterStatus}
                    allowClear={false}
                    className="table-select"
                    placeholder={col.placeholder ? col.placeholder : col.title}
                    onChange={handleStatusChange}
                    data={col.dropDown.map((item) => {
                      //  // Logging each item in the dropdown array
                      return {
                        label: item.name,
                        value: item.value,
                      };
                    })}
                    onClear={false}
                  />
                ) : null}
              </td>
            ))}
          </tr>
          {(filterName ||
            filterWard ||
            filterMail ||
            filterTerm ||
            filterPhone ||
            filterCreatedDate ||
            filterStatus?.value !== 2) && (
            <div className="clr-btn-container">
              <ButtonComp height={16} variant="link" onClick={clearFilters}>
                Clear filters
              </ButtonComp>
            </div>
          )}
          {!isLoading ? (
            currentPageData?.length > 0 ? (
              currentPageData.map((row) => (
                <tr className="table-row" key={row?.id}>
                  {column.map((col, colIndex) => {
                    //
                    return (
                      <td
                        style={{ width: col.width }}
                        className="table-data"
                        key={colIndex}
                      >
                        {colIndex === 0 ? (
                          <div className="flex align-center">
                            {row?.councilor_image?.length > 0 ? (
                              <span className="councilor_image">
                                <AvatarComp
                                  blue
                                  size={32}
                                  shape="square"
                                  src={row.councilor_image}
                                />
                              </span>
                            ) : (
                              <span className="councilor_image">
                                <AvatarComp size={32} shape="square" blue>
                                  {row[col?.key?.replace(" ", "")]?.charAt(0)}
                                </AvatarComp>
                              </span>
                            )}
                            <TooltipComp
                              title={row?.first_name + " " + row?.last_name}
                            >
                              <span
                                className="table-title ml-3"
                                onClick={() => {
                                  //
                                  onDataClick(row);
                                }}
                              >
                                {row?.first_name + " " + row?.last_name}
                              </span>
                            </TooltipComp>
                          </div>
                        ) : col.key === "councilor_status_flg" ? (
                          <div>
                            <TagComp
                              className={
                                row.councilor_status_flg === 1
                                  ? "ant-tag-green"
                                  : "ant-tag-red"
                              }
                            >
                              {row.councilor_status_flg === 1
                                ? "Active"
                                : "Inactive"}
                            </TagComp>
                          </div>
                        ) : col.key === "ward_code" ? (
                          row[col.key] && (
                            <div>
                              <TagComp className="orange">
                                {row[col.key]}
                              </TagComp>
                            </div>
                          )
                        ) : col.key === "type" ? (
                          <div>
                            <TagComp
                              className={`${
                                row.user_type === 1
                                  ? "ant-tag-orange "
                                  : "ant-tag-blue"
                              }`}
                            >
                              {row.user_type === 1
                                ? "CSD User"
                                : "Active Directory User"}
                            </TagComp>
                          </div>
                        ) : (
                          <TooltipComp title={row[col.key]}>
                            <span className="table-title ml-0 block">
                              {row[col.key]}
                            </span>
                          </TooltipComp>
                        )}

                        <div className="action-container">
                          {isPermit(7, "edit") && (
                            <ButtonComp
                              onClick={() => {
                                handleEdit(row);
                              }}
                              height={32}
                              rounded
                            >
                              <EditIcon />
                            </ButtonComp>
                          )}

                          {isPermit(7, "delete") && (
                            <ButtonComp
                              onClick={() => {
                                onDeleteAction(row);
                              }}
                              height={32}
                              rounded
                            >
                              <DeleteIcon />
                            </ButtonComp>
                          )}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <EmptyState />
            )
          ) : (
            Array(10)
              .fill(0)
              .map((_, index) => <SkeletonRow key={index} columns={column} />)
          )}
        </tbody>
      </table>
      <PaginationComp
        currentPageNo={currentPageNo}
        total={totalPageNo}
        onChange={handlePageChange}
      />
    </div>
  );
}
